module.exports = __webpack_public_path__ + "static/media/facebook.aa1e8c9c.svg";